import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Role, Rule, User } from "@aptsi-types";
import { environment } from "@env";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHandlingService } from "../shared/error-handling/error-handling.service";
import { API_ENDPOINTS } from "../user-management-endpoints";

interface GetRolesResponse {
  roles: Role[];
}

interface GetRoleResponse {
  role: Role;
}

@Injectable({
  providedIn: "root",
})
export class RoleService {
  private readonly roleUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) { }

  getRoles(currentPage: number, organizationId: string): Observable<Role[]> {
    return this.http
      .post<GetRolesResponse>(`${this.roleUrl}${API_ENDPOINTS.ROLE.FETCH}`, {
        currentPage,
        organizationId
      })
      .pipe(
        map((response) => response.roles),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  getAllRoles(organizationId: string): Observable<Role[]> {
    return this.http
      .post<GetRolesResponse>(`${this.roleUrl}${API_ENDPOINTS.ROLE.FETCHALL}`, {
        organizationId
      })
      .pipe(
        map((response) => response.roles),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }


  getRoleSearch(
    currentPage: number,
    searchText: String,
    filterByHeader: String,
    organizationId: string
  ): Observable<Role[]> {
    return this.http
      .post<GetRolesResponse>(`${this.roleUrl}${API_ENDPOINTS.ROLE.SEARCH}`, {
        currentPage,
        searchText,
        filterByHeader,
        organizationId
      })
      .pipe(
        map((response) => response.roles),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }



  getRole(roleId: string): Observable<Role> {
    return this.http
      .post<GetRoleResponse>(`${this.roleUrl}${API_ENDPOINTS.ROLE.GET}`, {
        roleId,
      })
      .pipe(
        map((response) => response.role),
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }

  deleteRole(roleId: string): Observable<Role> {
    return this.http
      .post<Role>(`${this.roleUrl}${API_ENDPOINTS.USER.DELETE}`, { roleId })
      .pipe(
        catchError((error) => this.errorHandlingService.handleError(error))
      );
  }
}